import React from "react";
import classNames from "classnames";
import { DropdownContext } from "@/components/shared/DropDown.tsx";

type LanguageListItemProps = {
  lang: { language: string; name: string };
  selectedLanguage: string;
  handleClick: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    language: string,
  ) => void;
  setSelectedLanguage: (language: string) => void;
};

export default function LanguageListItem({
  lang,
  selectedLanguage,
  handleClick,
  setSelectedLanguage,
}: LanguageListItemProps) {
  const dropdownContext = React.useContext(DropdownContext);

  return (
    <a
      className={classNames("dropdown-item translate-menu-item", {
        disabled: selectedLanguage === lang.language,
      })}
      href="#"
      onClick={(event) => {
        event.preventDefault();
        handleClick(event, lang.language);
        setSelectedLanguage(lang.language);
        dropdownContext?.onItemSelect?.();
      }}
    >
      {lang.name}
    </a>
  );
}
